var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-page',{attrs:{"title":_vm.$t('admins.add.title'),"previous":[{ label: _vm.$t('admins.title'), to: { name: 'admins' } }],"icon":"user-plus"}},[_c('admin-add-form')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }